<template lang="html">
  <div class="page-header">
      <div class="page-header-content">
          <h1 class="h1">{{pagename}}</h1>
      </div>
      <img :src="backgroundFile2" class="blured">
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    props: {
        pagename:{
            type: String,
            required: true,
        } ,
    },
    data() {
        return {
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'backgroundFile2',
        ]),
    },
};
</script>

<style lang="scss">
.page-header {
  position: relative;
  padding: 45px;
  overflow: hidden;
  background: black;
  margin: 0;
  .page-header-content {
    position: relative;
    z-index: 2;
    color: white;
    text-align: center;
    .h1 {
      font-size: 45px;
      font-weight: 200;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    .ico {
      font-size: 40px;
    }
    .number {
      font-size: 35px;
      line-height: 40px;
    }
    .desc {
      text-transform: uppercase;
    }
  }
  img.blured {
    width:100%;
    height:auto;
    position: absolute;
    top: 50%;
    opacity: .60;
    transform: translate(0,-50%) scale(1.1);
    filter: url('/static/img/blur.svg#blur');
    -webkit-filter: blur(10px);
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/PageHeader.vue